<template>
  <v-layout justify-center>
    <v-flex shrink>
      <v-btn
        @click="applyFiltersAndGetItems"
        color="teal lighten-2"
        :dark="!loadingItems"
        :disabled="loadingItems"
        :loading="loadingItems"
        round
      >
        <v-icon>search</v-icon>
        <span class="ml-2">{{ buttonMessage }}</span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState([
      "likePatternFilter",
      "loadingItems",
      "notLikePatternFilter",
      "onlyItemsWithTheirBestPrediction",
      "showItemsWithoutPredictions",
      "showOnlyCorrectPredictions"
    ]),
    buttonMessage() {
      return this.thereIsAnyFilterToApply
        ? "Aplicar filtros"
        : "Obtener items sin filtros";
    },
    thereIsAnyFilterToApply() {
      return (
        this.likePatternFilter ||
        this.notLikePatternFilter ||
        this.onlyItemsWithTheirBestPrediction ||
        this.showItemsWithoutPredictions ||
        this.showOnlyCorrectPredictions
      );
    }
  },
  methods: {
    ...mapActions(["applyFiltersAndGetItems"])
  }
};
</script>
